import React from "react";
import { createContext } from "react";
import { createRoot } from "react-dom/client";
import { ui } from "@euglena/compact";

export class UI<RootState, Chromosome> implements ui.UI {

    public context = createContext({} as Chromosome);
    private root: any;

    constructor(private App: React.ComponentType<{ state: RootState }>, state: RootState, private chromosome: Chromosome) {
        this.root = createRoot(document.getElementById("root")!);
    }

    public render(state: RootState) {
        const App = this.App;
        this.root.render(<this.context.Provider value={this.chromosome}><App state={state} /></this.context.Provider>);
    }
}

